import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
} from "reactstrap"

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'

import avatar from "../../assets/images/companies/img-4.png"
// actions
import { createCompany, companySuccess, companyError, updateCompany } from "../../store/actions";
import { profileSuccess, getProfile } from '../../store/auth/profile/actions';
import AddUserForm from '../Forms/AddUserForm'
import Moderators from '../Tables/Moderatos';
import Loader from "../../components/Loader";

const Dealer = props => {
  const { user, company } = props;
  const [isAddForm, setIsAddForm] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  // console.log('props on company', props);


  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Users" />

        <Row>
          <Col lg="12">
            {props.error && props.error ? (
              <Alert color="danger">{props.error}</Alert>
            ) : null}
            {props.success && props.success ? (
              <Alert color="success">{props.success}</Alert>
            ) : null}
          </Col>
        </Row>
        {isAddForm ?
          <AddUserForm
            role={"Dealer"}
            user={user}
            data={currentUser}
            close={setIsAddForm}
            loading={loading}
            setLoading={setLoading}
            setCurrentUser={setCurrentUser}
          />
          : <Card>
            <CardBody>
              <Moderators
                role={"Dealer"}
                user={props?.user}
                add={setIsAddForm}
                currentUser={currentUser}
                setCurrentUser={setCurrentUser}
                getProfile={props?.getProfile}
                updateCompany={props?.updateCompany}
              />
            </CardBody>
          </Card>
        }

      </div>
    </React.Fragment>
  )
}

Dealer.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  const { company } = state.Company;
  return { user, company }
}

export default withRouter(
  connect(mapStatetoProps, { createCompany, companySuccess, companyError, getProfile, updateCompany })(Dealer)
)
